var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2346 13.5367H22.999C22.999 10.5529 20.8477 7.83759 18.1723 7.83759C17.0415 7.83759 15.9934 8.28516 15.166 9.06096C16.2693 10.1948 17.0139 11.7464 17.2346 13.5367Z",
    fill: "#99A1A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.17 7.56437C19.5866 7.56437 20.735 6.32197 20.735 4.7894C20.735 3.25683 19.5866 2.01443 18.17 2.01443C16.7534 2.01443 15.605 3.25683 15.605 4.7894C15.605 6.32197 16.7534 7.56437 18.17 7.56437Z",
    fill: "#99A1A4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11596 9.33683C7.28853 8.53119 6.24045 8.02394 5.08205 8.02394C2.43427 8.02394 0.255371 10.7691 0.255371 13.7529H6.0198C6.24045 11.9924 7.01272 10.4707 8.11596 9.33683Z",
    fill: "#99A1A4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0831 7.81565C6.49973 7.81565 7.64814 6.57326 7.64814 5.04068C7.64814 3.50811 6.49973 2.26572 5.0831 2.26572C3.66647 2.26572 2.51807 3.50811 2.51807 5.04068C2.51807 6.57326 3.66647 7.81565 5.0831 7.81565Z",
    fill: "#99A1A4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.85693 15.3368V15.8368H5.35693H17.4926H17.9926V15.3368C17.9926 11.149 15.1175 7.58612 11.4248 7.58612C7.73202 7.58612 4.85693 11.149 4.85693 15.3368Z",
    fill: "#99A1A4",
    stroke: "#F3F4F6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4526 7.66726C13.2348 7.66726 14.6795 6.10425 14.6795 4.17618C14.6795 2.2481 13.2348 0.685089 11.4526 0.685089C9.67035 0.685089 8.22559 2.2481 8.22559 4.17618C8.22559 6.10425 9.67035 7.66726 11.4526 7.66726Z",
    fill: "#99A1A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.d290aadb4ef56209eb5a07cd9e26d55d.svg";
export { ForwardRef as ReactComponent };